var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import Page from "components/mobile_pay/views/page";
import CheckInfoComponent from "components/mobile_pay/views/check_info_component";
import CreditCardForm from "components/mobile_pay/views/credit_card_form";
export default function PaymentPage(props) {
    var merchantInfo = props.merchantInfo, checkInfo = props.checkInfo;
    return (React.createElement(Page, { merchantInfo: merchantInfo, signlePanelContent: false },
        React.createElement(CheckInfoComponent, { checkInfo: checkInfo }),
        React.createElement(CreditCardForm, __assign({}, props))));
}
